var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 351.6 351.6",
    style: {
      enableBackground: "new 0 0 351.6 351.6"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.2,84c0-0.4-0.4-0.8-0.8-1.2c-0.4-0.4-0.4-0.8-0.8-1.2l-76.4-80c-0.4-0.4-1.2-0.8-2-1.2     c0,0,0,0-0.4,0C225,0,224.2,0,223,0H51.8C48.2,0,45,3.2,45,6.8v338c0,3.6,3.2,6.8,6.8,6.8h248v-0.4c3.6,0,6.8-3.2,6.8-6.8v-258     C306.6,85.6,306.6,84.8,306.2,84z M230.2,23.2l54,56.4h-54V23.2z M293,337.6H58.6V13.2h158v73.6c0,3.6,3.2,6.8,6.8,6.8H293V337.6     z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,207.2h15.6c2,0,3.2-1.6,3.2-3.2v-36.8c0-2-1.6-3.2-3.2-3.2H123c-2,0-3.2,1.6-3.2,3.2V204     C119.4,205.6,121,207.2,123,207.2z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,208.4H173c2,0,3.2-1.6,3.2-3.2v-62c0-2-1.6-3.2-3.2-3.2h-15.6c-2,0-3.2,1.6-3.2,3.2v61.6     C154.2,206.8,155.4,208.4,157.4,208.4z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8,208.4h15.6c2,0,3.2-1.6,3.2-3.2v-89.6c0-2-1.6-3.2-3.2-3.2h-15.6c-2,0-3.2,1.6-3.2,3.2     v89.2C188.6,206.8,189.8,208.4,191.8,208.4z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,205.2c0,1.6,1.6,3.2,3.2,3.2h15.6c2,0,3.2-1.6,3.2-3.2v-71.6c0-2-1.6-3.2-3.2-3.2h-15.6     c-2,0-3.2,1.6-3.2,3.2V205.2z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,115.2c0-3.6-3.2-6.8-6.8-6.8c-3.6,0-6.8,3.2-6.8,6.8v108c0,3.6,3.2,6.8,6.8,6.8h147.6     c3.6,0,6.8-3.2,6.8-6.8c-0.4-4-3.2-6.8-7.2-6.8H109V115.2z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4,258.4h-72.8c-3.6,0-6.8,3.2-6.8,6.8s3.2,6.8,6.8,6.8h73.2c3.6,0,6.8-3.2,6.8-6.8     C256.2,261.6,253.4,258.4,249.4,258.4z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4,289.2h-72.8c-3.6,0-6.8,3.2-6.8,6.8s3.2,6.8,6.8,6.8h73.2c3.6,0,6.8-3.2,6.8-6.8     C256.2,292.4,253.4,289.2,249.4,289.2z",
    "data-original": "#231F20",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.8af233a6e2e7ef060d4b447fe5adb49e.svg";
export { ForwardRef as ReactComponent };